import { api } from ".";

// HST Import row result
export interface IHSTImportRowResult {
  patIdVisit: string;
  dos: string;
  patientName: string;
  success: boolean;
  orderId?: string;
  skipped?: boolean;
  updated?: boolean;
  existingOrderId?: string;
  errors?: Record<string, string>;
}

// HST Import overall result
export interface IHSTImportResult {
  totalRows: number;
  successCount: number;
  updateCount: number;
  errorCount: number;
  duplicateCount: number;
  csvDuplicateCount: number;
  skippedPayerCount: number;
  noInsuranceMatchCount: number;
  results: IHSTImportRowResult[];
}

// HST Import response
export interface IHSTImportResponse {
  data: IHSTImportResult;
  message: string;
}

// HST Import request params
export interface IHSTImportRequest {
  accountId: string;
  scheduledAppointments: File;
  insuranceInfo: File;
}

const integrationQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    hstImport: builder.mutation<IHSTImportResponse, IHSTImportRequest>({
      query: ({ accountId, scheduledAppointments, insuranceInfo }) => {
        const formData = new FormData();
        formData.append("accountId", accountId);
        formData.append("scheduledAppointments", scheduledAppointments);
        formData.append("insuranceInfo", insuranceInfo);

        return {
          url: "/integration/hst/import",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const { useHstImportMutation } = integrationQueries;
